(function () {
  /*
   * Desconto progressivo - destaque da faixa ativa.
   * Os valores de cada faixa vêm prontos do Liquid (snippet desconto-progressivo).
   * O tema recarrega o bloco quando o cliente troca de variante (cor/tamanho), por isso
   * este script sempre busca o elemento de novo no DOM em vez de guardar uma referência antiga.
   */

  function getQtyInput() {
    var selectors = [
      '.product-info input[name="quantity"]',
      'input[name="quantity"]',
      'input.quantity__input',
      'quantity-selector input'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getQty() {
    var input = getQtyInput();
    var qty = input ? parseInt(input.value || '1', 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function setActiveTier(acc, qty) {
    var tiers = Array.prototype.slice.call(acc.querySelectorAll('[data-tier]'));
    var best = null;

    tiers.forEach(function (row) {
      row.classList.remove('is-active');
      var minQty = parseInt(row.getAttribute('data-qty'), 10);
      if (qty >= minQty) best = row;
    });

    if (best) best.classList.add('is-active');
  }

  function refresh() {
    var qty = getQty();
    document.querySelectorAll('[data-vb-discount-accordion]').forEach(function (acc) {
      setActiveTier(acc, qty);
    });
  }

  var scheduled = false;
  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      refresh();
    });
  }

  function isQtyField(target) {
    return target && target.matches && target.matches('input[name="quantity"], input.quantity__input, quantity-selector input');
  }

  document.addEventListener('input', function (e) { if (isQtyField(e.target)) scheduleRefresh(); });
  document.addEventListener('change', function (e) { if (isQtyField(e.target)) scheduleRefresh(); });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('quantity-selector')) scheduleRefresh();
  });
  document.addEventListener('variant:change', scheduleRefresh, true);

  function observeRerender() {
    if (!('MutationObserver' in window)) return;
    var root = document.querySelector('.product-info') || document.body;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.matches('[data-vb-discount-accordion]') || node.querySelector('[data-vb-discount-accordion]'))) {
            scheduleRefresh();
            return;
          }
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    observeRerender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
